/** The face-safe crop (components.md 4): centred across, a fifth of the way down, applied at draw time. */
export const AVATAR_CROP = '50% 20%';

/** Initials at 40% of the diameter (components.md 4). */
export function avatarInitialsSize(size: number): number {
  return Math.round(size * 0.4);
}
